<script setup lang="ts">
import { useAppMenuItems } from '../composables/app-menu';
import AppMenuItem from './AppMenuItem.vue';

const items = useAppMenuItems();
</script>

<template>
    <ul class="layout-menu">
        <template v-for="(item, i) in items" :key="i">
            <AppMenuItem :item="item" root :index="i" />
            <li class="menu-separator"></li>
        </template>
    </ul>
</template>
